import { Inspector } from './Inspector';
import { InspectorConsole } from './Inspector/InspectorConsole';
import { Interpreter } from './Interpreter';
import { StateMachine } from './StateMachine';
function buildDefaultInspector(name) {
  return new Inspector({
    initialStatus: 'running',
    name
  });
}
export function createMachine(machineDefinition, options = {}) {
  const inspector = options.inspector || (options.debug ? new InspectorConsole({
    name: options.name || machineDefinition.initial
  }) : buildDefaultInspector(options.name));
  const machine = new StateMachine(machineDefinition, inspector, options.debug || false);
  const interpreter = new Interpreter(machine, options.initialContext);
  if (!options.waitToStart) {
    interpreter.start();
  }
  return interpreter;
}